import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-67c09371"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wrapper" }
const _hoisted_2 = { class: "groups" }
const _hoisted_3 = {
  key: 0,
  class: "groups__notification"
}
const _hoisted_4 = { class: "groups" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_loader = _resolveComponent("app-loader")!
  const _component_SpacesGroupDesc = _resolveComponent("SpacesGroupDesc")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.dataRequest)
      ? (_openBlock(), _createBlock(_component_app_loader, {
          key: 0,
          message: "Loading groups data ..."
        }))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        (_ctx.spacesStore.filteredByNameGroupsByOwnerId.length === 0)
          ? (_openBlock(), _createElementBlock("p", _hoisted_3, " You haven’t created any group yet. "))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.spacesStore.filteredByNameGroupsByOwnerId, (item) => {
            return (_openBlock(), _createBlock(_component_SpacesGroupDesc, {
              key: item.id,
              data: item
            }, null, 8, ["data"]))
          }), 128))
        ])
      ])
    ])
  ], 64))
}